import Switch from "react-input-switch";
import "./style.scss";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";
import { useAutomaticSummarization } from "../../../../hooks/useAutomaticSummarization";

export const AutomaticallySummarize = ({ isDisabled }) => {
  const { t } = useTranslation();
  const {
    isAutomaticallyGenerateSummaryEnabled,
    save,
    isLoading: isLoadingAutomaticSummarization,
    firstTime,
  } = useAutomaticSummarization();

  const [isLoading, setIsLoading] = useState(true);

  const userValue = useMemo(
    () => Number(isAutomaticallyGenerateSummaryEnabled || firstTime),
    [isAutomaticallyGenerateSummaryEnabled, firstTime]
  );

  const disabled = useMemo(
    () => isDisabled || isLoadingAutomaticSummarization,
    [isDisabled, isLoadingAutomaticSummarization]
  );

  const handleSubmit = useCallback(
    async (value) => {
      setIsLoading(true);
      save(!!value);
    },
    [save]
  );

  useEffect(() => {
    if (!isLoadingAutomaticSummarization) setIsLoading(false);
  }, [isLoadingAutomaticSummarization]);

  return (
    <div className="automatic-summary-container">
      <p className="automatic-summary-title">
        {t("Automatically summarize upcoming conversations")}
      </p>

      {isLoading ? (
        <Spinner
          size="sm"
          animation="border"
          style={{ cursor: "not-allowed" }}
        />
      ) : (
        <Switch
          onChange={handleSubmit}
          style={{ marginBottom: 0 }}
          disabled={disabled}
          value={userValue}
        />
      )}
    </div>
  );
};
